<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Отчёт о оплата
          <v-divider class="mx-2" inset vertical></v-divider>
       
            <export-excel
                :data="filteredKlentho"
                :worksheet="'Отчёт о оплата '"
                :name="'Лист1'"
                :title="'Отчёт о оплата'"
                :fields="json_fields"
                :auto-width="true"
                >
                <v-icon  color="success" >
                    mdi-microsoft-excel
                    </v-icon>
            </export-excel>


        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">



            <v-menu class="m-2"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date1"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date1"
                label="Дата 1"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date1"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Клиент"
            hide-details
            multiple
            solo

            :items="klents"
            item-text="fio"
            item-value="fio"
            class="m-4"
            @click:clear="get_karz"
            v-model="filters.fio" />

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Метод оплата"
            hide-details
            multiple
            solo
            :items="gnakds"
            item-text="nom"
            item-value="nom"
            class="m-4"
            @click:clear="get_karz"
            v-model="filters.nom_gnakd" />


          </v-col>

          <v-col cols="12" md="3">

            <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Дата 2"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu2 = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>


            <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo

             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_karz"
             v-model="filters.valuta" />



          </v-col>
          <v-col cols="12" md="4">

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Тип операции"
            hide-details
            multiple
            solo

            :items="oprs"
            item-text="nom"
            item-value="nom"

            @click:clear="get_karz"
            v-model="filters.namud_pardokht" />

              <v-text-field
              class="m-4"
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="search"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredKlentho"
        class="elevation-1"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
        :search="search">

        <!-- actions edit delete-->
        <template v-slot:item.actions="{ item }">

            <v-icon
            v-if="(item.np == 2 || item.np == 3) && dostup == 1 && item.status_smena!==3"
                small
                class="mr-2"
                color="warning"
                @click="editPardokht(item)"
            >
                mdi-pencil

            </v-icon>
            <v-icon
            v-if="(item.np == 2 || item.np == 3) && dostup == 1 && item.status_smena!==3"
                small
                color="error"
                @click="deletePardokht(item)"
            >
                mdi-delete
            </v-icon>
        </template>





          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumDolg('nal')).toFixed(2) }}</th>
                  <th class="title ">{{Number( sumDolg('beznal')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumDolg('summa')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>

              </tr>
          </template>

        </v-data-table>
      </v-container>



      <v-dialog
      v-model="delete_dialog"
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h5">
            Вы уверены что хотите удалить?
        </v-card-title>



        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="delete_dialog = false"
          >
            Отмена
          </v-btn>

          <v-btn
            color="error darken-1"
            text
            :disabled="loading"
            :loading="loading"
            @click="save_delete"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="edit_dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Изменить платеж № {{ info_pardokht.id_pardokht }}-{{ info_pardokht.fio }}
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-row>
                <v-col cols="12"  >
                    <v-text-field
                    v-model="info_pardokht.nal"
                    label="Наличий"
                    type="number"
                    required
                    ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="info_pardokht.np==2" >
                    <v-select
                    :items="gnakds"
                    v-model="info_pardokht.id_gnakd"
                    label="Метод оплата"
                    required
                    item-text="nom"
                    item-value="id_gnakd"
                    ></v-select>
                </v-col>


                <v-col cols="12"   v-if="info_pardokht.id_gnakd>0 && info_pardokht.np==2">
                    <v-text-field
                    v-model="info_pardokht.beznal"
                    label="Без.нал"
                    type="number"
                    required
                    ></v-text-field>
                </v-col>


                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="edit_dialog = false"
          >
            Отмена
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="save_change_pardokht"
          >
            Изменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

    dostup:0,

  searching: "",
  search: "",

    pokupka_dialog: false,
    vozvrat_dialog: false,

  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
    ],

    oprs: [
        {nom: "Оплата при покупки"},
        {nom: "Оплата долга"},
        {nom: "Долг до программы"},
    ],

  gnakds: [
   {nom: "Бонусный", id_gnakd: "1.000"},
    {nom: "Душанбе сити", id_gnakd: "2.000"},
    {nom: "Эсхата Онлайн", id_gnakd: "3.000"},
    {nom: "Алиф", id_gnakd: "4.000"},


  ],

  klents:[],

      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,


firma_info:{},

filters: {
    fio: "",
    nom: "",
    valuta: "",
    firma: "",
    comment: "",
    opr:"",
    nom_gnakd:"",
    namud_pardokht:""
},

karzdoron: [],

headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id_pardokht',
        },
        { text: 'Клиент', value: 'fio' },
        { text: 'Телефон', value: 'tel' },
        { text: 'Валюта', value: 'valuta' },
        { text: 'Наличий', value: 'nal' },
        { text: 'Без.нал', value: 'beznal' },
        { text: 'Метод оплата', value: 'nom_gnakd' },
        { text: 'Сумма', value: 'summa' },
        { text: 'Коментарий', value: 'ezoh' },
        { text: 'Дата', value: 'created_at' },
        { text: 'Действие', value: 'actions', sortable: false },


],


snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
vipiska:[],
id_firma:0,

ost_na_nachalo:0,
summa_pokupka:0,
summa_skidka:0,
summa_oplata:0,
summa_vozvrat:0,
ost_dolga:0,
karz_firma:0,
kharid:[],
vozvrat:[],
id:0,

info_pardokht:{},
delete_dialog: false,
edit_dialog: false,



        json_fields: {

        'ID': 'id_pardokht',
        'Клиент': 'fio' ,
        'Телефон': 'tel' ,
        'Валюта': 'valuta' ,
        'Наличий': 'nal' ,
        'Без.нал': 'beznal' ,
        'Метод оплата': 'nom_gnakd' ,
        'Сумма': 'summa' ,
        'Коментарий': 'ezoh' ,
        'Дата': 'created_at' ,

        },

        










}),

mounted(){


  this.get_klents();
  this.get_karz();
  this.$session.start();
  this.dostup = this.$session.get('dostup');
},

methods: {

    get_klents(){
          this.loading = true;
        axios.get('/api/get_klents',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.klents = response.data.klents;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumDolg(key) {
  return  this.filteredKlentho.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },
  sumVipiska(key) {
  return  this.filteredVipiska.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  get_karz(){
    this.loading = true;

          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)

    this.karzdoron = [];

    axios.post('/api/oplata_klentho',{start:this.date1, end:this.date2},
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.karzdoron = response.data.dolgi
                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.karzdoron = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.karzdoron = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
  },


  dblclick_firma(event, {item}){
      this.firma_info = item;
      this.sumfurush_card = false
      this.furush_card = true;
      this.id_firma = item.id_firma;
      this.karz_firma = item.karz
      this.get_vipiska()

  },

  open_vipiska_info(event, {item}){
    if(item.ITEM==1){
        this.get_pokupka(item.ID)
        this.id = item.ID
    }else if(item.ITEM==5){
        this.get_vozvrat(item.ID)
        this.id = item.ID
    }
  },

  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
  },

  get_vipiska(){


            try{
                this.$refs.menu1.save(this.date1)
                this.$refs.menu2.save(this.date2)
            }catch(e){
               // console.log(e)
            }




            axios.post('/api/get_vipiska/'+this.id_firma, {start: this.date1, end:this.date2},
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.vipiska = response.data.vipiska
                                    this.ost_na_nachalo = response.data.ost_na_nachalo
                                    this.summa_pokupka = response.data.summa_pokupka
                                    this.summa_skidka = response.data.summa_skidka
                                    this.summa_oplata = response.data.summa_oplata
                                    this.summa_vozvrat = response.data.summa_vozvrat
                                    this.ost_dolga = response.data.ost_dolga

                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.karzdoron = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.karzdoron = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                console.log(error.response.data.message)
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });

  },




  close_dialog_vp(){
    this.pokupka_dialog = false;
    this.vozvrat_dialog = false;
    this.kharid = [];
    this.vozvrat = [];
  },

  deletePardokht(item){
    this.delete_dialog = true;
    this.info_pardokht = item;

  },
  editPardokht(item){
    this.edit_dialog = true;
    this.info_pardokht = item;
    console.log(item)
  },

  save_delete(){
    this.loading = true;
    axios.post('/api/delete_pardokht_klent', {id: this.info_pardokht.id_pardokht},  {
        headers: {
            "Content-type": "application/json"
        }
    })
    .then(response => {
            if(response.data.status){
            this.loading = false;
            this.delete_dialog = false;
            this.snack = true
            this.snackColor = 'success'
            this.snackText = "Партия успешно удалена"
            console.log(response.data.message)
            this.get_karz();
            setTimeout(() => {
                this.snack = false;
            }, 2000);

            }else{
                this.loading = false;
                this.snack = true
                this.snackColor = 'error'
                this.snackText = "Не удалось удалить партию"
                setTimeout(() => {
                    this.snack = false;
                }, 2000);

            }

        })
        .catch(error => {
            this.loading = false;
           this.snack = true
            this.snackColor = 'error'
            this.snackText = error.response.data.message;
                setTimeout(() => {
                    this.snack = false;
                }, 2000);
        });

  },

  save_change_pardokht(){
    this.loading = true;
    axios.post('/api/edit_pardokht_klent',this.info_pardokht,  {
        headers: {
            "Content-type": "application/json"
        }
    })
    .then(response => {
            if(response.data.status){
            this.loading = false;
            this.edit_dialog = false;
            this.snack = true
            this.snackColor = 'success'
            this.snackText = "Оплата успешно изменена"
            this.get_karz();
            setTimeout(() => {
                this.snack = false;
            }, 2000);

            }else{
                this.loading = false;
                this.snack = true
                this.snackColor = 'error'
                this.snackText = "Не удалось изменить партию"
                setTimeout(() => {
                    this.snack = false;
                }, 2000);

            }

        })
        .catch(error => {
            this.loading = false;
           this.snack = true
            this.snackColor = 'error'
            this.snackText = error.response.data.message;
                setTimeout(() => {
                    this.snack = false;
                }, 2000);
        });


  }


},


computed: {

    filteredKlentho() {
    let filter = this.karzdoron.filter((id_klent) => {
    for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false
    let dropdownValue = id_klent[key];
    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},

filteredVipiska() {
  let filter = this.vipiska.filter((FIRMA) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = FIRMA[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},


}

}
</script>

<style  scoped>

</style>



